/* ============================================
   QUIZ RESULTS — Dynamic Content Controller
   Reads URL params and personalizes the results page
   ============================================ */

(function () {
  'use strict';

  /* --- 1. Parse URL parameters --- */
  var params = new URLSearchParams(window.location.search);
  var gender = params.get('g') || '';        // male, female, neutral
  var age = params.get('age') || '';          // 18-24, 25-34, 35-44, 45-54, 55+
  var area = params.get('area') || '';        // hairline, crown, partline, diffuse, unsure
  var severity = params.get('sev') || '';     // mild, moderate, advanced
  var tried = params.get('tried') || '';      // comma-separated: minoxidil,supplements,serums,shampoo,prp,finasteride,laser

  var variant = params.get('v') || sessionStorage.getItem('fc_quiz_variant') || 'a';

  var triedList = tried ? tried.split(',').map(function (s) { return s.trim().toLowerCase(); }) : [];
  var hasParams = !!(gender || area || severity);

  // --- A/B Variant Config for Advertorial ---
  var EXPERIMENT_CONFIG_URL = 'https://quiz-funnel-analytics.fly.dev/api/experiment-config';
  var AD_DEFAULTS = { hookParagraphs: 4, baCount: 4, ctaText: null, headline: null, defaultSupply: null };
  var AD_CONFIG = AD_DEFAULTS;

  // If no variant assigned yet (direct landing on advertorial), do our own assignment
  if (!variant || variant === 'a') {
    // Check if there's a cached experiment that includes advertorial scope
    try {
      var cached = sessionStorage.getItem('fc_experiment_config');
      if (cached) {
        var exp = JSON.parse(cached);
        if (exp.active && (exp.scope === 'ad_only' || exp.scope === 'quiz_and_ad')) {
          // Assign variant if not already assigned
          if (!sessionStorage.getItem('fc_quiz_variant')) {
            var traffic = exp.trafficPct || 50;
            variant = (Math.random() * 100) < traffic ? 'b' : 'a';
            sessionStorage.setItem('fc_quiz_variant', variant);
          }
          if (variant === 'b') {
            sessionStorage.setItem('fc_ad_config', JSON.stringify(exp.adConfig || {}));
          }
        }
      }
    } catch(e) {}
  }

  // Fetch experiment config if we don't have it yet (direct advertorial landing)
  if (EXPERIMENT_CONFIG_URL && !sessionStorage.getItem('fc_ad_config') && !sessionStorage.getItem('fc_experiment_config')) {
    // Synchronous-ish: fetch and apply before page renders personalized content
    // Using XMLHttpRequest for sync capability on advertorial page
    try {
      var xhr = new XMLHttpRequest();
      xhr.open('GET', EXPERIMENT_CONFIG_URL, false); // synchronous
      xhr.timeout = 2000;
      xhr.send();
      if (xhr.status === 200) {
        var exp = JSON.parse(xhr.responseText);
        sessionStorage.setItem('fc_experiment_config', xhr.responseText);
        if (exp.active && (exp.scope === 'ad_only' || exp.scope === 'quiz_and_ad')) {
          var traffic = exp.trafficPct || 50;
          variant = (Math.random() * 100) < traffic ? 'b' : 'a';
          sessionStorage.setItem('fc_quiz_variant', variant);
          if (variant === 'b') {
            sessionStorage.setItem('fc_ad_config', JSON.stringify(exp.adConfig || {}));
          }
        }
      }
    } catch(e) {}
  }

  // Apply ad config for variant B
  if (variant === 'b') {
    try {
      var storedAdConfig = sessionStorage.getItem('fc_ad_config');
      if (storedAdConfig) {
        var parsed = JSON.parse(storedAdConfig);
        AD_CONFIG = {
          hookParagraphs: parsed.hookParagraphs || 4,
          baCount: parsed.baCount || 4,
          ctaText: parsed.ctaText || null,
          headline: parsed.headline || null,
          defaultSupply: parsed.defaultSupply || null,
        };
      }
    } catch(e) {}
  }

  // Persist quiz answers to localStorage for product page personalization
  if (hasParams) {
    try {
      localStorage.setItem('fc_quiz', JSON.stringify({ g: gender, age: age, area: area, sev: severity }));
    } catch(e) {}
  }

  /* --- Headline A/B Testing (7 formula variants) --- */
  var HEADLINE_VARIANTS = [
    { id: 'hl-a', formula: 'how', eyebrow: 'YOUR PERSONALIZED RESULTS \u00B7 7 MIN READ', headline: null },
    { id: 'hl-b', formula: 'why', eyebrow: 'WHY YOUR TREATMENT FAILS \u00B7 7 MIN READ', headline: 'See Why 47,000 People Switched From Topical Serums to This Micro-Infusion System' },
    { id: 'hl-c', formula: 'authority', eyebrow: 'CLINICAL RESEARCH REPORT \u00B7 7 MIN READ', headline: 'Trichologists Now Say 95% of Hair Serums Never Reach the Follicle \u2014 One Device Changes That' },
    { id: 'hl-d', formula: 'question', eyebrow: 'THE DELIVERY PROBLEM \u00B7 7 MIN READ', headline: 'Is Your $40 Hair Serum Actually Reaching Your Follicles? The Science Says Probably Not.' },
    { id: 'hl-e', formula: 'this_device', eyebrow: 'BREAKTHROUGH TECHNOLOGY \u00B7 7 MIN READ', headline: 'This At-Home Micro-Infusion System Delivers 18\u00D7 More Active Ingredients Than Any Topical Serum' },
    { id: 'hl-f', formula: 'conspiracy', eyebrow: 'WHAT THEY DON\u2019T TELL YOU \u00B7 7 MIN READ', headline: 'The Hair Loss Industry Doesn\u2019t Want You to Know That 95% of Your Serum Evaporates Before It Works' },
    { id: 'hl-g', formula: 'is_device', eyebrow: 'YOUR RESULTS ARE IN \u00B7 7 MIN READ', headline: 'Is This the Smartest Way to Treat Thinning Hair Without Finasteride, Minoxidil, or Clinic Visits?' }
  ];

  // Assign headline variant from cookie or randomly
  var hlVariant = null;
  try {
    var hlCookie = document.cookie.match(/fc_hl_variant=([^;]+)/);
    if (hlCookie) {
      hlVariant = HEADLINE_VARIANTS.find(function(v) { return v.id === hlCookie[1]; });
    }
    if (!hlVariant) {
      var hlIdx = Math.floor(Math.random() * HEADLINE_VARIANTS.length);
      hlVariant = HEADLINE_VARIANTS[hlIdx];
      document.cookie = 'fc_hl_variant=' + hlVariant.id + ';path=/;max-age=2592000';
    }
  } catch(e) {
    hlVariant = HEADLINE_VARIANTS[0];
  }

  // Track headline variant assignment
  try {
    var HL_TRACK_URL = 'https://quiz-funnel-analytics.fly.dev/api/quiz-event';
    var hlSession = sessionStorage.getItem('fc_quiz_session_id') || ('hl-' + Math.random().toString(36).substr(2, 12));
    navigator.sendBeacon(HL_TRACK_URL, JSON.stringify({
      session_id: hlSession,
      shop: 'follicleandco.myshopify.com',
      event_type: 'headline_variant',
      step_name: 'advertorial_headline',
      step_index: 99,
      answer_value: hlVariant.id + '|' + hlVariant.formula,
      progress: 100,
      timestamp: new Date().toISOString()
    }));
  } catch(e) {}

  /* Normalize gender/area for lookups */
  var g = gender || 'neutral';
  var a = area || 'unsure';

  /* --- 2. Headline (gender + area + age) --- */
  var fallbackHeadline = "I Spent $4,200 on Hair Products Before a Dermatologist Told Me Why None of Them Could Work";

  var ageOpenerMap = {
    'under25': "You\u2019re in your 20s",
    '18-24': "You\u2019re in your 20s",
    '25-34': "You\u2019re in your 30s",
    '35-44': "You\u2019re in your 40s",
    '45-54': "You\u2019re in your 50s",
    '55+': ""
  };

  var areaStatementMap = {
    'male+crown': "and your crown is thinning",
    'male+hairline': "and your hairline is receding",
    'male+diffuse': "and your hair is thinning everywhere",
    'male+partline': "and your hair is thinning at the part",
    'female+partline': "and your part line is widening",
    'female+crown': "and your crown is thinning",
    'female+diffuse': "and your hair is thinning all over",
    'female+hairline': "and your hairline is thinning",
    'neutral+crown': "and your hair is thinning",
    'neutral+hairline': "and your hair is thinning",
    'neutral+diffuse': "and your hair is thinning",
    'neutral+partline': "and your hair is thinning",
    'neutral+unsure': "and you\u2019re noticing changes",
    'male+unsure': "and you\u2019re noticing changes",
    'female+unsure': "and you\u2019re noticing changes"
  };

  var headlineCloserMap = {
    'male': "Here\u2019s why nothing has worked.",
    'female': "Here\u2019s what most products miss.",
    'neutral': "Here\u2019s what actually works."
  };

  function setHeadline() {
    var el = document.getElementById('qrHeadline');
    if (!el) return;

    // A/B headline variant override (if variant has a fixed headline)
    if (hlVariant && hlVariant.headline) {
      el.textContent = hlVariant.headline;
      return;
    }

    // A/B: headline override from experiment config
    if (AD_CONFIG.headline) {
      el.textContent = AD_CONFIG.headline;
      return;
    }

    if (!hasParams) {
      el.textContent = fallbackHeadline;
      return;
    }

    var ageOpener = ageOpenerMap[age] !== undefined ? ageOpenerMap[age] : '';
    var areaKey = g + '+' + a;
    var areaStatement = areaStatementMap[areaKey] || areaStatementMap[g + '+unsure'] || "and you\u2019re noticing changes";
    var closer = headlineCloserMap[g] || headlineCloserMap['neutral'];

    if (ageOpener) {
      el.textContent = ageOpener + ' ' + areaStatement + '. ' + closer;
    } else {
      var capArea = areaStatement.replace(/^and\s+/, '');
      capArea = capArea.charAt(0).toUpperCase() + capArea.slice(1);
      el.textContent = capArea + '. ' + closer;
    }
  }

  /* --- 3. Personalized hook copy (JS-built from gender × area × age) --- */
  var hookOpenings = {
    'male+under25': "You\u2019re a man in your early 20s.",
    'male+18-24': "You\u2019re a man in your early 20s.",
    'male+25-34': "You\u2019re a man in your 30s.",
    'male+35-44': "You\u2019re a man in your 40s.",
    'male+45-54': "You\u2019re a man in your 50s.",
    'male+55+': "You\u2019ve been dealing with this for years.",
    'female+under25': "You\u2019re a woman in your early 20s.",
    'female+18-24': "You\u2019re a woman in your early 20s.",
    'female+25-34': "You\u2019re a woman in your 30s.",
    'female+35-44': "You\u2019re a woman in your 40s.",
    'female+45-54': "You\u2019re a woman in your 50s.",
    'female+55+': "You\u2019ve been dealing with this for years."
  };

  var hookAreaObservations = {
    'crown': "You first noticed your crown thinning \u2014 maybe your barber mentioned it, or you caught it in a photo taken from behind.",
    'hairline': "Your hairline started creeping back at the temples. You noticed it in photos first. Then in the mirror every morning.",
    'partline': "It started when your part line looked wider than it used to. More scalp showing through. Harder to style around.",
    'diffuse': "It\u2019s not one spot \u2014 it\u2019s everywhere. Thinner in the shower. More hair on the pillow. Less volume overall.",
    'unsure': "Something changed. You\u2019re not sure exactly what or where, but your hair isn\u2019t what it used to be."
  };

  var hookFailedAttempts = {
    'male': "You tried the biotin supplements. The thickening shampoo. The serum your friend recommended.",
    'female': "You tried the volumizing shampoo. The biotin gummies. The rosemary oil routine from TikTok. The serum from Sephora.",
    'neutral': "You tried the supplements. The shampoos. The serums. The routines."
  };

  var hookClosers = {
    'crown': "Your crown kept getting thinner.",
    'hairline': "Your temples kept creeping back.",
    'partline': "The part kept widening.",
    'diffuse': "The thinning kept spreading.",
    'unsure': "Nothing changed."
  };

  var cdnBase = 'https://cdn.shopify.com/s/files/1/0998/3610/0740/files/';

  var hookImageMap = {
    'male+crown': 'adv-hook-male-crown.png',
    'male+hairline': 'adv-hook-male-hairline.png',
    'male+diffuse': 'adv-hook-male-crown.png',
    'male+partline': 'adv-hook-male-crown.png',
    'male+unsure': 'adv-hook-male-crown.png',
    'female+partline': 'adv-hook-female-partline.png',
    'female+crown': 'adv-hook-female-crown.png',
    'female+diffuse': 'adv-hook-female-partline.png',
    'female+hairline': 'adv-hook-female-partline.png',
    'female+unsure': 'adv-hook-female-partline.png',
    'neutral+crown': 'adv-hook-diffuse.png',
    'neutral+hairline': 'adv-hook-diffuse.png',
    'neutral+partline': 'adv-hook-diffuse.png',
    'neutral+diffuse': 'adv-hook-diffuse.png',
    'neutral+unsure': 'adv-hook-diffuse.png'
  };

  function setHookCopy() {
    var hookContent = document.getElementById('qrHookContent');
    var hookImage = document.getElementById('qrHookImage');

    // Also handle legacy gender variant elements (hide them all — we use qrHookContent now)
    var maleHook = document.getElementById('qrHookMale');
    var femaleHook = document.getElementById('qrHookFemale');
    var neutralHook = document.getElementById('qrHookNeutral');
    if (maleHook) maleHook.style.display = 'none';
    if (femaleHook) femaleHook.style.display = 'none';
    if (neutralHook) neutralHook.style.display = 'none';

    if (!hookContent) return;

    if (!hasParams) {
      // Fallback: show neutral legacy hook if available, or generic text
      if (neutralHook) {
        neutralHook.style.display = 'block';
      }
      return;
    }

    // Build opening
    var openingKey = g + '+' + (age || '25-34');
    var opening = hookOpenings[openingKey];
    if (!opening) {
      opening = (g === 'neutral') ? "You\u2019ve been watching this happen." : hookOpenings[g + '+25-34'] || "You\u2019ve been watching this happen.";
    }

    var areaObs = hookAreaObservations[a] || hookAreaObservations['unsure'];
    var failedAttempt = hookFailedAttempts[g] || hookFailedAttempts['neutral'];
    var hookCloser = hookClosers[a] || hookClosers['unsure'];

    var hookParagraphs = [
      '<p>' + opening + ' ' + areaObs + '</p>',
      '<p>' + failedAttempt + ' ' + hookCloser + '</p>',
      '<p><strong>Still thinning.</strong></p>',
      '<p>Then a dermatologist explained something that changed everything:</p>'
    ];
    // A/B: limit hook length based on variant
    var maxParagraphs = AD_CONFIG.hookParagraphs || 4;
    var hookHTML = hookParagraphs.slice(0, maxParagraphs).join('');

    hookContent.innerHTML = hookHTML;

    // Set hook image
    if (hookImage) {
      var imgKey = g + '+' + a;
      var imgFile = hookImageMap[imgKey] || hookImageMap['neutral+unsure'];
      hookImage.src = cdnBase + imgFile;
    }
  }

  /* --- 4. Science opening (area-specific) --- */
  var scienceOpenings = {
    'crown': "The follicles at your crown sit 3\u20134mm below the surface \u2014 in an area with the highest concentration of DHT receptors on your scalp. No topical serum can reach them.",
    'hairline': "Your temple follicles are the most genetically sensitive to DHT. They sit 3\u20134mm below a barrier of dead skin cells. No serum you rub on your hairline can passively reach them.",
    'partline': "The follicles along your part line are shrinking because of reduced blood flow and hormonal sensitivity. They sit 3\u20134mm below the surface \u2014 unreachable by topical products.",
    'diffuse': "Follicles across your entire scalp are affected by multiple mechanisms \u2014 DHT, blood flow, growth cycles, stem cell dormancy. They all sit 3\u20134mm below a barrier that blocks 95% of every serum.",
    'unsure': "Your follicles sit 3\u20134mm below a wall of dead skin cells called the stratum corneum. 95% of every serum you apply never reaches them."
  };

  function setScienceOpening() {
    var el = document.getElementById('qrScienceOpening');
    if (!el) return;
    el.textContent = scienceOpenings[a] || scienceOpenings['unsure'];
  }

  /* --- 5. Breakthrough heading (area-specific) --- */
  var breakthroughHeadings = {
    'crown': "What if a clinical-grade formula could reach your crown follicles directly?",
    'hairline': "What if a formula could bypass the barrier and reach your temple follicles?",
    'partline': "What if you could deliver a clinical formula directly to your part line follicles?",
    'diffuse': "What if a formula could reach every affected follicle across your scalp?",
    'unsure': "What if a clinical-grade formula could bypass the skin entirely?"
  };

  function setBreakthroughHeading() {
    var el = document.getElementById('qrBreakthroughHeading');
    if (!el) return;
    el.textContent = breakthroughHeadings[a] || breakthroughHeadings['unsure'];
  }

  /* --- 6. Formula callout (area-specific) --- */
  var formulaCallouts = {
    'crown': 'For crown thinning, <strong>Redensyl 3.0%</strong> is the key \u2014 it reactivates dormant stem cells at the vertex. Combined with Procapil for DHT reduction.',
    'hairline': 'For hairline recession, <strong>Procapil 2.5% + Capixyl 2.5%</strong> are the core \u2014 they block DHT locally at the temple follicles without systemic side effects.',
    'partline': 'For part line widening, <strong>GHK-Cu</strong> triggers growth factor signaling while <strong>Caffeine + Arginine</strong> restore blood flow along the central scalp.',
    'diffuse': 'For diffuse thinning, all 6 ingredients work together \u2014 <strong>no single pathway is enough</strong> when thinning is happening everywhere.',
    'unsure': 'Our formula covers <strong>all 6 biological pathways</strong> \u2014 wherever thinning develops, every mechanism is addressed.'
  };

  function setFormulaCallout() {
    var el = document.getElementById('qrFormulaCallout');
    if (!el) return;
    el.innerHTML = formulaCallouts[a] || formulaCallouts['unsure'];
  }

  /* --- 7. Evidence card reorder (area-based) --- */
  function reorderEvidence() {
    var cards = document.querySelectorAll('.adv2-evidence-card');
    if (!cards.length) return;

    var keywordMap = {
      'crown': 'redensyl',
      'hairline': 'procapil',
      'partline': 'adenosine'
    };

    var keyword = keywordMap[a];
    if (!keyword) return; // diffuse/unsure: keep original order

    var parent = cards[0].parentElement;
    var targetCard = null;

    cards.forEach(function (card) {
      if (!targetCard && card.textContent.toLowerCase().indexOf(keyword) !== -1) {
        targetCard = card;
      }
    });

    if (targetCard && targetCard !== parent.firstChild) {
      parent.insertBefore(targetCard, parent.firstChild);
    }
  }

  /* --- 8. Show/hide B&A pairs (existing logic preserved) --- */
  function showMatchedBA() {
    var pairs = document.querySelectorAll('.qr-ba-pair');
    if (!pairs.length) return;

    // Collect matching pairs
    var exactMatches = [];
    var genderMatches = [];
    var allPairs = [];

    pairs.forEach(function (el) {
      allPairs.push(el);
      var baGender = el.getAttribute('data-ba-gender') || '';
      var baArea = el.getAttribute('data-ba-area') || '';

      if (baGender === g && baArea === a) {
        exactMatches.push(el);
      }
      if (baGender === g) {
        genderMatches.push(el);
      }
    });

    var toShow;

    // A/B: configurable number of B&A pairs shown
    var maxBA = AD_CONFIG.baCount || 4;

    if (!hasParams) {
      // Fallback: show a mix
      toShow = allPairs.slice(0, maxBA + 2);
    } else if (exactMatches.length >= maxBA) {
      // Show first N immediately, rest available via "see more"
      toShow = exactMatches.slice(0, maxBA);
      // Mark remaining exact matches as "more" for toggle
      exactMatches.slice(maxBA).forEach(function(el) {
        el.classList.add('qr-ba-more');
        el.style.display = '';
        el.style.display = 'none';
      });
    } else if (exactMatches.length > 0) {
      // Fill remaining from gender matches (excluding already-selected)
      toShow = exactMatches.slice();
      var remaining = maxBA - toShow.length;
      genderMatches.forEach(function (el) {
        if (remaining <= 0) return;
        if (toShow.indexOf(el) === -1) {
          toShow.push(el);
          remaining--;
        }
      });
    } else if (genderMatches.length > 0) {
      toShow = genderMatches.slice(0, 4);
    } else if (g === 'neutral') {
      // For neutral, show a mix of male and female
      var maleOnes = [];
      var femaleOnes = [];
      allPairs.forEach(function (el) {
        var bg = el.getAttribute('data-ba-gender') || '';
        if (bg === 'male') maleOnes.push(el);
        else if (bg === 'female') femaleOnes.push(el);
      });
      toShow = [];
      for (var i = 0; i < 2 && i < maleOnes.length; i++) toShow.push(maleOnes[i]);
      for (var j = 0; j < 2 && j < femaleOnes.length; j++) toShow.push(femaleOnes[j]);
      if (toShow.length < 4) {
        allPairs.forEach(function (el) {
          if (toShow.length < 4 && toShow.indexOf(el) === -1) toShow.push(el);
        });
      }
    } else {
      toShow = allPairs.slice(0, 4);
    }

    toShow.forEach(function (el) {
      el.classList.add('visible');
    });
  }

  /* --- 9. B&A heading (gender + area) --- */
  function setBaHeading() {
    var el = document.getElementById('qrBaHeading');
    if (!el) return;

    // Diffuse overrides gender-specific text
    if (a === 'diffuse') {
      var genderLabel = g === 'male' ? 'Men' : g === 'female' ? 'Women' : 'People';
      el.textContent = genderLabel + ' like you who reversed their diffuse thinning';
      return;
    }

    var baHeadings = {
      'male+crown': 'Men like you who reversed their crown thinning',
      'male+hairline': 'Men like you who reversed their hairline recession',
      'female+partline': 'Women like you who reversed their part line widening',
      'female+crown': 'Women like you who reversed their crown thinning'
    };

    var key = g + '+' + a;
    if (baHeadings[key]) {
      el.textContent = baHeadings[key];
    } else if (g === 'neutral' || !baHeadings[key]) {
      el.textContent = 'People like you who reversed their thinning';
    }
  }

  /* --- 10. Failed solutions cards (existing logic preserved) --- */
  function showFailedSolutions() {
    var cards = document.querySelectorAll('.qr-failure');
    if (!cards.length) return;

    if (!hasParams || triedList.length === 0) {
      // Show all cards as fallback
      cards.forEach(function (el) {
        el.classList.add('visible');
      });
      return;
    }

    cards.forEach(function (el) {
      var triedVal = (el.getAttribute('data-tried') || '').toLowerCase();
      if (triedList.indexOf(triedVal) !== -1) {
        el.classList.add('visible');
      }
    });

    // If none matched somehow, show all
    var visibleCount = document.querySelectorAll('.qr-failure.visible').length;
    if (visibleCount === 0) {
      cards.forEach(function (el) {
        el.classList.add('visible');
      });
    }
  }

  /* --- 11. How it works — Step 2 apply text (area-specific) --- */
  var applyTexts = {
    'crown': "Apply in circular motions from the center of your crown outward. Spend 2\u20133 minutes on the vertex area.",
    'hairline': "Apply in horizontal strokes along your hairline. Be gentle at the temples \u2014 light pressure is enough.",
    'partline': "Apply along your part and 1cm on each side. Work front to back in slow, controlled strokes.",
    'diffuse': "Divide your scalp into 4 quadrants. Spend equal time on each to ensure full coverage.",
    'unsure': "Focus on areas where you notice the most change. Apply with gentle, even pressure."
  };

  function setApplyText() {
    var el = document.getElementById('qrApplyText');
    if (!el) return;
    el.textContent = applyTexts[a] || applyTexts['unsure'];
  }

  /* --- 12. Timeline note (age-specific) --- */
  var timelineNotes = {
    'under25': "At your age, you may see results faster. Younger follicles respond more readily.",
    '18-24': "At your age, you may see results faster. Younger follicles respond more readily.",
    '25-34': "In your 30s, expect the standard timeline. Month 3\u20134 is the inflection point.",
    '35-44': "In your 40s, the growth cycle is slower. Don\u2019t judge before month 4.",
    '45-54': "In your 50s, give it the full 6 months. Improvements may continue beyond.",
    '55+': "Extended timeline \u2014 6\u20139 months for full assessment. Consistency is everything."
  };

  function setTimelineNote() {
    var el = document.getElementById('qrTimelineNote');
    if (!el) return;
    el.textContent = timelineNotes[age] || timelineNotes['25-34'];
  }

  /* --- 13. Gender-matched reviews --- */
  function showMatchedReviews() {
    var reviews = document.querySelectorAll('.adv2-review[data-review-gender]');
    if (!reviews.length) return;

    if (g === 'neutral' || !hasParams) {
      // Show first 3 regardless
      var count = 0;
      reviews.forEach(function (el) {
        if (count < 3) {
          el.classList.add('visible');
          count++;
        }
      });
      return;
    }

    var shown = 0;
    reviews.forEach(function (el) {
      var reviewGender = el.getAttribute('data-review-gender') || '';
      if (reviewGender === g && shown < 3) {
        el.classList.add('visible');
        shown++;
      }
    });

    // Fallback: if fewer than 3 matched, fill with any
    if (shown < 3) {
      reviews.forEach(function (el) {
        if (shown >= 3) return;
        if (!el.classList.contains('visible')) {
          el.classList.add('visible');
          shown++;
        }
      });
    }
  }

  /* --- 14. Supply recommendation (existing logic preserved) --- */
  function highlightSupply() {
    var cards = document.querySelectorAll('.qr-supply-card');
    if (!cards.length) return;

    // Remove any existing recommendation
    cards.forEach(function (el) {
      el.classList.remove('qr-supply-card--recommended');
    });

    var recommendedSupply;
    // A/B: override default supply if variant specifies one
    if (AD_CONFIG.defaultSupply) {
      recommendedSupply = String(AD_CONFIG.defaultSupply);
    } else if (severity === 'mild') {
      recommendedSupply = '1';
    } else if (severity === 'moderate' || severity === 'advanced') {
      recommendedSupply = '3';
    } else {
      recommendedSupply = '3';
    }

    cards.forEach(function (el) {
      var supply = el.getAttribute('data-supply') || '';
      if (supply === recommendedSupply) {
        el.classList.add('qr-supply-card--recommended');
      }
    });
  }

  /* --- 15. Urgency text (severity + age) --- */
  var ageUrgencyPrepend = {
    'under25': "At your age, early action has the highest return. ",
    '18-24': "At your age, early action has the highest return. ",
    '25-34': "In your 30s, the follicles you save now determine your density for the next decade. ",
    '35-44': "In your 40s, every month of delay means more follicles past the point of return. ",
    '45-54': "In your 50s, maximizing what\u2019s still viable is the priority. ",
    '55+': ""
  };

  function setUrgency() {
    var urgencyText = document.getElementById('qrUrgencyText');
    var urgencySub = document.getElementById('qrUrgencySub');
    if (!urgencyText) return;

    if (!hasParams || !severity) {
      urgencyText.textContent = "Every month you wait, follicles miniaturize further. The ones you lose today are exponentially harder to reactivate tomorrow.";
      if (urgencySub) urgencySub.textContent = "The best time to start was when you first noticed thinning. The second best time is today.";
      return;
    }

    var messages = {
      mild: {
        text: "Your follicles are still active \u2014 but the window is closing. Mild thinning is the easiest stage to reverse, but only if you act before follicles go dormant.",
        sub: "Catch it now and you may never need anything stronger. Wait, and you\u2019ll wish you hadn\u2019t."
      },
      moderate: {
        text: "Your follicles are miniaturizing. Every month you wait, more of them slip into dormancy \u2014 and dormant follicles are exponentially harder to reactivate.",
        sub: "You\u2019re past the easy window. But you\u2019re not past the point of no return \u2014 yet. Start today."
      },
      advanced: {
        text: "You\u2019re in the critical window. Some of your follicles may already be beyond reactivation. The ones that remain active today won\u2019t stay that way forever.",
        sub: "This is not about vanity. It\u2019s about biology. The longer you wait, the fewer follicles are left to save."
      }
    };

    var msg = messages[severity] || messages.moderate;
    urgencyText.textContent = msg.text;

    if (urgencySub) {
      var agePrepend = ageUrgencyPrepend[age] !== undefined ? ageUrgencyPrepend[age] : '';
      urgencySub.textContent = agePrepend + msg.sub;
    }
  }

  /* --- 16. CTA button text based on supply (existing logic preserved) --- */
  function updateCTAs() {
    var ctaButtons = document.querySelectorAll('.qr-cta-btn');
    if (!ctaButtons.length) return;

    var price = '$99';
    if (severity === 'moderate' || severity === 'advanced') {
      price = '$210';
    }

    ctaButtons.forEach(function (btn) {
      // A/B: override CTA text if variant specifies one
      if (AD_CONFIG.ctaText) {
        btn.textContent = AD_CONFIG.ctaText;
      } else {
        var template = btn.getAttribute('data-cta-template');
        if (template) {
          btn.textContent = template.replace('{price}', price);
        }
      }
    });
  }

  /* --- 17. Eyebrow personalization (existing logic preserved) --- */
  function setEyebrow() {
    var el = document.getElementById('qrEyebrow');
    if (!el) return;

    // A/B headline variant eyebrow override
    if (hlVariant && hlVariant.eyebrow) {
      el.textContent = hlVariant.eyebrow;
      return;
    }

    if (!hasParams) {
      el.textContent = 'HAIR SCIENCE \u00B7 7 MIN READ';
      return;
    }

    el.textContent = 'YOUR PERSONALIZED RESULTS \u00B7 7 MIN READ';
  }

  /* --- Initialize --- */
  function init() {
    setEyebrow();
    setHeadline();
    setHookCopy();
    setScienceOpening();
    setBreakthroughHeading();
    setFormulaCallout();
    reorderEvidence();
    showMatchedBA();
    setBaHeading();
    showFailedSolutions();
    setApplyText();
    setTimelineNote();
    showMatchedReviews();
    highlightSupply();
    setUrgency();
    updateCTAs();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* --- 18. Scroll Depth & Section Visibility Tracking --- */
  try {
    var SCROLL_API = 'https://quiz-funnel-analytics.fly.dev/api/scroll-event';
    var scrollSessionId = sessionStorage.getItem('fc_quiz_session_id');

    if (scrollSessionId) {
      var scrollBuffer = [];
      var reachedMilestones = {};
      var pageLoadTime = Date.now();
      var scrollSent = false;

      function pushScrollEvent(scrollPct, sectionName) {
        scrollBuffer.push({
          session_id: scrollSessionId,
          shop: 'follicleandco.myshopify.com',
          page_url: window.location.pathname,
          scroll_pct: scrollPct,
          section_name: sectionName || null,
          time_on_page: Math.round((Date.now() - pageLoadTime) / 1000),
          timestamp: new Date().toISOString()
        });
      }

      function flushScrollBuffer() {
        if (scrollBuffer.length === 0 || scrollSent) return;
        scrollSent = true;
        try {
          navigator.sendBeacon(SCROLL_API, JSON.stringify(scrollBuffer));
        } catch (e) {}
      }

      /* Scroll milestone tracking (throttled) */
      var scrollThrottleTimer = null;
      function onScroll() {
        if (scrollThrottleTimer) return;
        scrollThrottleTimer = setTimeout(function () {
          scrollThrottleTimer = null;
          var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          var docHeight = Math.max(
            document.body.scrollHeight,
            document.documentElement.scrollHeight
          ) - window.innerHeight;
          if (docHeight <= 0) return;
          var pct = Math.round((scrollTop / docHeight) * 100);

          var milestones = [25, 50, 75, 100];
          for (var i = 0; i < milestones.length; i++) {
            var m = milestones[i];
            if (pct >= m && !reachedMilestones[m]) {
              reachedMilestones[m] = true;
              pushScrollEvent(m, null);
            }
          }
        }, 200);
      }

      window.addEventListener('scroll', onScroll, { passive: true });

      /* Section visibility tracking via IntersectionObserver */
      if (typeof IntersectionObserver !== 'undefined') {
        var trackedSections = {};
        var sectionObserver = new IntersectionObserver(function (entries) {
          for (var i = 0; i < entries.length; i++) {
            var entry = entries[i];
            if (entry.isIntersecting) {
              var name = entry.target.getAttribute('data-track-section');
              if (name && !trackedSections[name]) {
                trackedSections[name] = true;
                var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                var docHeight = Math.max(
                  document.body.scrollHeight,
                  document.documentElement.scrollHeight
                ) - window.innerHeight;
                var pct = docHeight > 0 ? Math.round((scrollTop / docHeight) * 100) : 0;
                pushScrollEvent(pct, name);
                sectionObserver.unobserve(entry.target);
              }
            }
          }
        }, { threshold: 0.3 });

        var sections = document.querySelectorAll('[data-track-section]');
        for (var s = 0; s < sections.length; s++) {
          sectionObserver.observe(sections[s]);
        }
      }

      /* Flush on page exit */
      window.addEventListener('beforeunload', function () {
        /* Add final time-on-page event */
        pushScrollEvent(
          Math.round(((window.pageYOffset || document.documentElement.scrollTop) /
            Math.max(1, Math.max(document.body.scrollHeight, document.documentElement.scrollHeight) - window.innerHeight)) * 100),
          null
        );
        flushScrollBuffer();
      });

      window.addEventListener('visibilitychange', function () {
        if (document.visibilityState === 'hidden') {
          flushScrollBuffer();
          /* Allow re-send if user returns and scrolls more */
          scrollSent = false;
        }
      });
    }
  } catch (e) {
    /* Scroll tracking failed silently — do not break page */
  }
})();
